import { Close } from '@mui/icons-material';
import {
  Avatar,
  Box,
  Dialog,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import useShallowEqualSelector from 'hooks/useShallowEqualSelector';

const AccountSettings = ({ open, onClose }) => {
  const user = useShallowEqualSelector((state) => state.publicUser.user);
  const info = [
    {
      label: 'Name',
      value: user?.fullName,
    },
    {
      label: 'Phone number',
      value: user?.phoneNumber,
    },
  ];
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={'sm'}
      PaperProps={{
        sx: {
          borderRadius: '12px',
        },
      }}
    >
      <Box p={2} pb={'100px'}>
        <Stack flexDirection={'row'} alignItems={'center'}>
          <Typography flex={1} fontWeight={700} fontSize={16}>
            Account Settings
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Stack>
        <Stack flexDirection={'row'} gap={4} mt={2}>
          <Box>
            <Avatar
              sx={{
                height: 138,
                width: 138,
              }}
              src={user?.avatar}
            >
              {user?.fullName}
            </Avatar>
          </Box>
          <Stack gap={2} flex={1}>
            {info.map((i) => {
              return (
                <Box key={i.label}>
                  <Typography>{i.label}</Typography>
                  <TextField
                    value={i.value}
                    disabled
                    fullWidth
                    sx={{
                      mt: 1,
                    }}
                    InputProps={{
                      sx: {
                        borderRadius: '8px',
                      },
                    }}
                    inputProps={{
                      style: {
                        padding: '8px 16px',
                      },
                    }}
                  />
                </Box>
              );
            })}
          </Stack>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default AccountSettings;
